import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'

class ConfirmOrder extends React.Component {
  constructor (props) {
    super (props)
    this.dateFormat = 'DD MMM YYYY, h:mm:ss a'
    this.state = {
      transfer_amount: 0,
      payment_notes: ''
    }
  }

  componentDidMount = () => {
    this._fetchData()
  }

  _fetchData = (id = this.props.detail.id) => {
    this.props.getData(id)
  }

  _submit = (event) => {
    event.preventDefault()
    const form = {...this.state}
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.submit(data)
    this.props.closeModal()
  }

  render() {
    const { order } = this.props
    const data = order.data_single
    return (
      <form onSubmit={(event) => this._submit(event)} className="section" style={{ width: '40vw' }}>
        <header className="title-block">
          <h4 className="title mr-auto">
            Confirm Order
            {(order.fetching || order.processing) && 
              <div className="badge badge-info ml-2">{order.fetching ? 'Loading' : 'Processing'} ...</div> 
            }
          </h4>
        </header>

        <div className="form-group row">
          <div className="col-4">
            <label className="control-label">Order ID</label>
          </div>
          <div className="col-8">
            <input type="text" readOnly className="form-control" value={data.order_number}/>
          </div>
        </div>

        <div className="form-group row">
          <div className="col-4">
            <label className="control-label">Total Order</label>
          </div>
          <div className="col-8">
            <input type="text" readOnly className="form-control" value={data.final_amount}/>
          </div>
        </div>

        <div className="form-group row">
          <div className="col-4">
            <label className="control-label">Full Name</label>
          </div>
          <div className="col-8">
            <input type="text" readOnly className="form-control" value={data.salutation + ' ' + data.first_name + ' ' + data.last_name}/>
          </div>
        </div>

        <div className="form-group row">
          <div className="col-4">
            <label className="control-label">Phone Number</label>
          </div>
          <div className="col-8">
            <input type="text" readOnly className="form-control" value={data.phone_number}/>
          </div>
        </div>

        <div className="form-group row">
          <div className="col-4">
            <label className="control-label">Total Transfer</label>
          </div>
          <div className="col-8">
            <input type="number" required className="form-control" value={this.state.transfer_amount} onChange={(event) => this.setState({ transfer_amount: event.target.value })}/>
          </div>
        </div>

        <div className="form-group row">
          <div className="col-4">
            <label className="control-label">Notes (Optional)</label>
          </div>
          <div className="col-8">
            <textarea className="form-control" placeholder="Notes (Optional)" value={this.state.payment_notes} onChange={(event) => this.setState({ payment_notes: event.target.value })}/>
          </div>
        </div>

        <div className="text-right">
          <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
          <button type="submit" className="btn btn-lg btn-primary">Confirm</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  getData: (id) => dispatch(OrderActions.orderSingleRequest(id)),
  submit: (data) => dispatch(OrderActions.orderConfirmRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ConfirmOrder)



// WEBPACK FOOTER //
// ./src/Containers/Order/ConfirmOrder.js